/**
 * shadeColor takes a color and a percentage and returns
 * a new string that is either lighter or darker.
 *
 * @param color a hexadecimal color
 * @param percent should be between -100 (to darken) and 100 (to lighten)
 */
export const shadeColor = (color: string, percent: number): string => {
  let R: number = parseInt(color.substring(1, 3), 16)
  let G: number = parseInt(color.substring(3, 5), 16)
  let B: number = parseInt(color.substring(5, 7), 16)

  R = parseInt(((R * (100 + percent)) / 100).toString(), 10)
  G = parseInt(((G * (100 + percent)) / 100).toString(), 10)
  B = parseInt(((B * (100 + percent)) / 100).toString(), 10)

  R = R < 255 ? R : 255
  G = G < 255 ? G : 255
  B = B < 255 ? B : 255

  const RR = R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16)
  const GG = G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16)
  const BB = B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16)

  return `#${RR}${GG}${BB}`
}
